import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { FaUserLarge } from "react-icons/fa6";
import styles from '../search.module.css';
import { apiCall } from '../utills/APICall';
import { useNavigate } from 'react-router-dom';

export default function LoginForm() {
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const navigate = useNavigate();

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('Form data:', formData);

        const response = await apiCall('login', 'POST', formData);
        console.log("LOGIN RESPONSE", response);

        if (response && response.success) {
            const { accessToken, refreshToken } = response.data.data;
            localStorage.setItem('adminToken', accessToken);
            localStorage.setItem('refreshToken', refreshToken);
            navigate('/');
        } else {
            console.error("Login failed:", response.message);
        }
    };

    return (
        <div className={styles.loginFormContainer}>
            <div className={styles.loginForm}>
                <h2 className={styles.title}>Login</h2>
                <div className={styles.inputGroup}>
                    <label htmlFor="email">Email</label>
                    <div className={styles.passwordWrapper}>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            placeholder="Enter your email"
                            value={formData.email}
                            onChange={handleInputChange}
                            required
                        />
                        <span className={styles.passwordToggle} >
                            <FaUserLarge />
                        </span>
                    </div>
                </div>
                <div className={styles.inputGroup}>
                    <label htmlFor="password">Password</label>
                    <div className={styles.passwordWrapper}>
                        <input
                            type={showPassword ? 'text' : 'password'}
                            id="password"
                            name="password"
                            placeholder="Enter your password"
                            value={formData.password}
                            onChange={handleInputChange}
                            required
                        />
                        <span className={styles.passwordToggle} onClick={togglePasswordVisibility}>
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </span>
                    </div>
                </div>
                <button onClick={handleSubmit} className={styles.loginbutton}>Login</button>
            </div>
        </div>
    );
}
